import React from "react"

import SEO from "../components/seo"
// import Layout from '../layouts/findep'
import Simulador from '../components/pages/Simulador'
import CardBenefits from '../components/afi/CardBenefits'
import LayoutsComponent from '../layouts/LayoutsComponent';


const SimuladorPage = ({ pageContext, location }) => {
  return (
    <LayoutsComponent
      layout={pageContext.layout}
      pageContext={pageContext}
      location={location}
      gradient
      menu
      companyName={pageContext.company}
      broker={pageContext.broker}
      render={() => (
        <>
          <SEO title={pageContext.title} />
          <Simulador pageContext={pageContext} />
          <br />
          {pageContext.company === "AFI" ?
            <CardBenefits /> : ''}
        </>
      )}
    />
  )
}

export default SimuladorPage